import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../common/api";

// Async Thunk برای گرفتن داده‌ها
export const fetchStocks = createAsyncThunk("stocks/fetchStocks", async (_, { rejectWithValue }) => {
  try {
    const response = await api.get("/Home/stocks");
    if (response.data.success) {
      return response.data.data; // فقط داده‌های موفق بازگردانده شوند
    } else {
      return rejectWithValue(response.data.message || "خطایی رخ داده است");
    }
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || error.message);
  }
});

const stocksSlice = createSlice({
  name: "stocks",
  initialState: {
    stocks: [],
    status: "idle", // idle | loading | succeeded | failed
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchStocks.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchStocks.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.stocks = action.payload; // داده‌ها ذخیره می‌شوند
      })
      .addCase(fetchStocks.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default stocksSlice.reducer;
